import { useUserQuery } from '@alluradirect/react';
import { useMemo } from 'react';

export type LoginState = 'loading' | 'loggedin' | 'notloggedin';

interface Args {
  propertyId: string | undefined;
}

export const useLoginState = ({ propertyId }: Args) => {
  const userQuery = useUserQuery({
    isReloadUser: true,
    hasToastsEnabled: false,
    enabled: Boolean(propertyId),
  });

  const userId = userQuery?.data?.DATA?.USER ? userQuery.data.DATA.USER.ID : undefined;

  const loginState: LoginState = useMemo(() => {
    if (!userQuery.data) return 'loading';
    if (!userQuery.data.DATA.USER) return 'notloggedin';
    return Object.keys(userQuery.data.DATA.USER).length > 0 ? 'loggedin' : 'notloggedin';
  }, [userQuery.data]);

  return {
    userQuery,
    userId,
    loginState,
  };
};
